import { VerifiedAddress } from '../addressVerificationTypes';

export default function diffAddress(a: VerifiedAddress, b: VerifiedAddress) {
  return (
    a.primaryLine !== b.primaryLine
    || a.secondaryLine !== b.secondaryLine
    || a.city !== b.city
    || a.state !== b.state
    || a.zip !== b.zip
  );
}
